import { render, staticRenderFns } from "./panorama.vue?vue&type=template&id=3635a091&scoped=true"
import script from "./panorama.vue?vue&type=script&lang=js"
export * from "./panorama.vue?vue&type=script&lang=js"
import style0 from "./panorama.vue?vue&type=style&index=0&id=3635a091&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3635a091",
  null
  
)

export default component.exports